import { render, staticRenderFns } from "./InstagramInstantwinAnalyticsPublicSummary.vue?vue&type=template&id=5d543ef8"
import script from "./InstagramInstantwinAnalyticsPublicSummary.vue?vue&type=script&lang=ts"
export * from "./InstagramInstantwinAnalyticsPublicSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports